import { createSlice } from "@reduxjs/toolkit";

export interface createCertificateModalInterface {
    isCreateEmployeeModalOpen?: boolean;
    isPostCreateEmployeeSuccess?: boolean;
    formValues?: {
        firstName: string;
        lastName: string;
        insertion?: string;
        functionGroups: { selectedId: string; selectedValue: string }[];
        establishment: { selectedId: string; selectedValue: string };
        privateEmail: string;
        businessEmail: string;
        telephone: string;
        dateOfBirth: string;
        placeOfBirth: string;
    };
    functionGroupInputValue?: string;
    error?: string;
    isAddAgainButtonClicked: boolean;
}

const initialState: createCertificateModalInterface = {
    isCreateEmployeeModalOpen: false,
    isPostCreateEmployeeSuccess: false,
    isAddAgainButtonClicked: false,
};

const CreateEmployeeModalSlice = createSlice({
    name: "createEmployeeModal",
    initialState,
    reducers: {
        setIsCreateEmployeeModalOpen: (state, action) => {
            state.isCreateEmployeeModalOpen = action.payload;
        },
        setIsPostCreateEmployeeSuccess: (state, action) => {
            state.isPostCreateEmployeeSuccess = action.payload;
        },
        setFunctionGroupInputValue: (state, action) => {
            state.functionGroupInputValue = action.payload;
        },
        setFormValues: (state, action) => {
            state.formValues = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setIsAddAgainButtonClicked: (state, action) => {
            state.isAddAgainButtonClicked = action.payload;
        },
    },
});

export const createEmployeeModalReducer = CreateEmployeeModalSlice.reducer;

export const {
    setIsCreateEmployeeModalOpen,
    setFormValues,
    setError,
    setFunctionGroupInputValue,
    setIsPostCreateEmployeeSuccess,
    setIsAddAgainButtonClicked,
} = CreateEmployeeModalSlice.actions;
